export enum AuthSecondFactor {
    none = 0,
    mail = 1
}
export namespace AuthSecondFactor{
    export function getName(value: AuthSecondFactor): string {
        switch (value) {
            case AuthSecondFactor.none:
                return "none";
            case AuthSecondFactor.mail:
                return "mail";
            default:
                return "???";
        }
    }
}
